import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonSelect } from '@ionic/angular';
import { User } from 'src/app/micro-services/user/models/user';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-coach-home',
  templateUrl: './coach-home.component.html',
  styleUrls: ['./coach-home.component.scss'],
})
export class CoachHomeComponent implements OnInit {

  @ViewChild('mySelect', { static: false }) selectRef: IonSelect;

  public appPages = [
    { title: 'Dashboard', url: 'dashboard', icon: 'home' },
    { title: 'Finances', url: 'dashboard-finance', icon: 'analytics' },

    { title: 'Clients', url: 'userList', icon: 'person' },
    { title: 'Calendrier', url: 'sessionDay', icon: 'time' },
    { title: 'Formules', url: 'formuleList', icon: 'card' },
    { title: 'Adresses', url: 'addressList', icon: 'map' },
    { title: 'Paiements', url: 'payments-list', icon: 'cash' },
    { title: 'Signaler un bug', url: 'reportBug', icon: 'bug' },
  ];

  coach: User;

  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit() {
    this.coach = this.userService.getUser();
  }

  logout() {
    let firebaseTokenUserId = localStorage.getItem('firebaseTokenUserId');
    localStorage.clear();
    localStorage.setItem('firebaseTokenUserId', firebaseTokenUserId);
    this.router.navigateByUrl("");
  }

  openSelect() {
    this.selectRef.open();
  }

  accountSelecChange() {
    this.router.navigateByUrl("/coach/account");
  }

}
